import { type LoaderFunctionArgs, redirect } from "react-router";
import { buildCompanyPath } from "@/hooks/companyPath";

export const legacyAgentPersonalityRedirect = ({
  params,
  request,
}: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  return redirect(
    buildCompanyPath(
      params.slug,
      `/agents/${params.id}/greeting${url.search}${url.hash}`,
    ),
  );
};
